<template>
    <div>
        <div class="mb-3 p-3 rounded">    
            <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2">
                <div class="justify-content-start d-flex">
                    <h4><strong>Colaboradores activos</strong></h4>
                </div>
                <div class="justify-content-end d-lg-flex d-md-flex d-sm-grid">
                    <a :href="go_to_users" class="text-decoration-underline">Ver detalles</a>
                </div>
            </div>
        </div>
        <div>
            <apexchart height="300" type="bar" :options="options" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
export default {
    props: [
        "graphicoestudiantes",
        "urlstudentsdetail",
        "go_to_users"
    ],
    data(){
        return{
            options: {
                chart: {
                    id: 'vuechart-activeusers'
                },
                xaxis: {
                    categories: ["Día 1", "Día 2", "Día 3", "Día 4", "Día 5", "Día 6", "Día 7"]
                },
                /*yaxis: {
                    title: {
                        text: "Usuarios"
                    }
                },*/
                colors: ['#4000BC']
            },
            series: [{
                name: 'Cantidad de usuarios',
                data: [10, 10, 10, 10, 10, 10, 10]
            }]
        }
    },
    mounted(){
        this.series = [{
            name: 'Cantidad de usuarios activos',
            data: this.formatData()
        }];
    },
    watch: {
        graphicoestudiantes(newVal, oldVal){
            this.series = [{
                name: 'Cantidad de usuarios activos',
                data: this.formatData(newVal)
            }];
        }
    },
    methods:{
        formatData(nuevoValor){
            let datos = nuevoValor;
            let newDatos = [];
            if(typeof datos != "undefined"){
                datos.forEach((el)=>{
                    newDatos.push(el.cantidad);
                });
            }
            return newDatos;
        }
    }
}
</script>

<style>
</style>